import React from 'react';
import PropTypes from 'prop-types';

export default function ATT({ twilioNumber }) {
  return (
    <div>
      <ul>
        <li>Step 0: Drain any unread messages in your voicemail</li>
        <li>Step 1: Dial *90 {twilioNumber} &gt; then press # &gt; hang up</li>
        <li>Step 2: Dial *92 {twilioNumber} &gt; then press # &gt; hang up</li>
      </ul>
    </div>
  );
}

ATT.defaultProps = {
  twilioNumber: '',
};

ATT.propTypes = {
  twilioNumber: PropTypes.string,
};
